import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VsText',
  props: {
    tag: { default: 'p' },
    type: { default: 'paragraph' },
    truncate: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    bold: { type: Boolean, default: false },
    overFlowWrap: { default: 'break-word' }
  },
  setup(__props: any) {

const props = __props as { tag: string, type: string, truncate: boolean, center: boolean, bold: boolean, overFlowWrap: string }

/**
 * Text is used to add a supporting text to your screen
 */


const overFlowWrapStyle = computed(() => ({
  'overflow-wrap': props.overFlowWrap,
}))

return { __sfc: true,props, overFlowWrapStyle }
}

})